var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92447 12.9337L10.5735 9.63378C12.5888 7.81138 12.5888 4.8566 10.5735 3.03415C8.55821 1.2117 5.29075 1.2117 3.27545 3.03415C1.26015 4.8566 1.26015 7.81138 3.27545 9.63378L6.92447 12.9337ZM6.92447 14.8193L2.23287 10.5767C-0.358224 8.23345 -0.358224 4.43449 2.23287 2.09134C4.82397 -0.251802 9.02494 -0.251802 11.6161 2.09134C14.2072 4.43449 14.2072 8.23345 11.6161 10.5767L6.92447 14.8193ZM6.92447 7.66732C7.7388 7.66732 8.3989 7.07038 8.3989 6.33398C8.3989 5.5976 7.7388 5.00065 6.92447 5.00065C6.11014 5.00065 5.45004 5.5976 5.45004 6.33398C5.45004 7.07038 6.11014 7.66732 6.92447 7.66732ZM6.92447 9.00065C5.29586 9.00065 3.97562 7.80672 3.97562 6.33398C3.97562 4.86122 5.29586 3.66732 6.92447 3.66732C8.55305 3.66732 9.87332 4.86122 9.87332 6.33398C9.87332 7.80672 8.55305 9.00065 6.92447 9.00065Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.9233f05f1022677a855a0052778fc98b.svg";
export { ForwardRef as ReactComponent };